import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { SkeletonAnimation } from '../../skeleton-loader.types';

@Component({
  selector: 'cm-skeleton-stat-tiles',
  standalone: true,
  imports: [],
  templateUrl: './skeleton-stat-tiles.component.html',
  styleUrl: './skeleton-stat-tiles.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SkeletonStatTilesComponent {
  public readonly animation = input<SkeletonAnimation>('shimmer');
  public readonly tileCount = input<number>(4);
}
